import { Input, toInt, useGridFilterUrlContext } from '@finbeat/react-toolkit';
import { FundsTransferDetailsFilter as FilterType } from 'models/api/fundsTransferDetails';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

const FundsTransferDetailsFilter = () => {
    const { draftFilter, setDraftFilter } = useGridFilterUrlContext<FilterType>();
    const { t } = useTranslation();
    return (
        <>
            <Row>
                <Col>
                    <Input
                        id="ftd-filter-registryId"
                        value={draftFilter.registryId}
                        disabled
                        label={t('BackOfficeLoanRegistryId')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        type="number"
                        id="ftd-filter-orderId"
                        value={draftFilter.orderId || ''}
                        onChange={(e) =>
                            setDraftFilter((prevState) => ({
                                ...prevState,
                                orderId: toInt(e.target.value),
                            }))
                        }
                        label={t('BackOfficeAppId')}
                    />
                </Col>
                <Col>
                    <Input
                        id="ftd-filter-phone"
                        value={draftFilter.phone || ''}
                        onChange={(e) =>
                            setDraftFilter((prevState) => ({
                                ...prevState,
                                phone: e.target.value,
                            }))
                        }
                        label={t('BackOfficePhone')}
                    />
                </Col>
            </Row>
        </>
    );
};

export default FundsTransferDetailsFilter;
